import { useState } from 'react';
import DemoSection from '../DemoSection';
import { UIInput } from '../WebComponents';

export default function InputDemo() {
  const [inputValue, setInputValue] = useState('');

  return (
    <DemoSection title="Input 输入框" description="通过鼠标或键盘输入内容">
      <DemoSection.Item title="基础用法">
        <div className="demo-content">
          <UIInput
            label="用户名"
            placeholder="请输入用户名"
            value={inputValue}
            onUiInput={(e: any) => setInputValue(e.detail.value)}
          />
        </div>
        <div className="code-block">
          <code>{`<UIInput
  label="用户名"
  placeholder="请输入用户名"
  value={inputValue}
  onUiInput={(e) => setInputValue(e.detail.value)}
/>`}</code>
        </div>
      </DemoSection.Item>

      <DemoSection.Item title="错误状态">
        <div className="demo-content">
          <UIInput
            label="邮箱"
            type="email"
            placeholder="请输入邮箱"
            error="请输入有效的邮箱地址"
          />
        </div>
        <div className="code-block">
          <code>{`<UIInput
  label="邮箱"
  type="email"
  placeholder="请输入邮箱"
  error="请输入有效的邮箱地址"
/>`}</code>
        </div>
      </DemoSection.Item>

      <DemoSection.Item title="禁用状态">
        <div className="demo-content">
          <UIInput label="禁用输入" placeholder="禁用状态" disabled />
        </div>
        <div className="code-block">
          <code>{`<UIInput label="禁用输入" placeholder="禁用状态" disabled />`}</code>
        </div>
      </DemoSection.Item>
    </DemoSection>
  );
}
